import get from 'lodash/get'
import Logger from '@/logger'

/**
 * Default settings object
 */
const defaultSettings = {
  LAUNCH_DATE: String(process.env.VUE_APP_LAUNCH_DATE)
}

/**
 * Global settings object with settings merged from config.js, window.Settings
 * and settings.local.js
 */
const Settings = {
  ...defaultSettings,
  ...(window.Settings || {}), // update settings from window.Settings

  /**
   * Return setting by name.
   *
   * If setting is undefined, return null and log an error.
   * @param path
   * @param defaultValue
   */
  get (path, defaultValue = null) {
    const value = get(this, path)

    if (typeof value === 'undefined') {
      Logger.warn(`[Settings] ${JSON.stringify(path)} is undefined.`)
      return defaultValue
    }

    return value
  }
}

export default Settings
